import { IGetGoogleMapPolyline } from '../types/location'
import { ICoordinatesWithShortKeyDTO, IAutoCompleteRequestDTO } from '../types/google-map'
import { ICoordinates } from '../types'

class GoogleMapService {
  public autoCompleteService: any
  public geocoder: any
  public placesService: any
  public directionsService: any

  constructor() {
    this.autoCompleteService = new window.google.maps.places.AutocompleteService()
    this.geocoder = new window.google.maps.Geocoder()
    //PlacesService needs a map instance or a dom node to work
    this.placesService = new window.google.maps.places.PlacesService(document.createElement('div'))
    this.directionsService = new window.google.maps.DirectionsService()
  }

  public async getPlacePredictions(query: IAutoCompleteRequestDTO) {
    return new Promise((resolve, reject) => {
      this.autoCompleteService.getPlacePredictions(query, (data: any, status: string) => {
        if (status === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      })
    })
  }

  public async geocode(placeId: string) {
    return new Promise((resolve, reject) => {
      this.geocoder.geocode({ placeId }, (data: any, status: string) => {
        if (status === 'OK') {
          const location = data instanceof Array ? data[0] : data
          console.log(location)
          resolve({
            formatted_address: location.formatted_address,
            lat: location.geometry.location.lat(),
            lng: location.geometry.location.lng()
          })
        } else {
          reject(data)
        }
      })
    })
  }

  public async getDirections(dto: IGetGoogleMapPolyline) {
    return new Promise((resolve, reject) => {
      const { destination, origin, waypoints } = dto
      const request = {
        origin,
        destination,
        waypoints,
        travelMode: 'DRIVING'
      }
      this.directionsService.route(request, (data: any, status: string) => {
        if (status === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      })
    })
  }

  public async getDriveTime(origin: ICoordinates, destination: ICoordinates): Promise<{ text: string; value: number }> {
    return new Promise((resolve, reject) => {
      const request = {
        origin,
        destination,
        travelMode: 'DRIVING'
      }
      this.directionsService.route(request, (data: any, status: string) => {
        if (status === 'OK' && data.routes && data.routes[0]) {
          const route = data.routes[0]
          const leg = route.legs ? route.legs[0] : null
          const duration = leg ? leg.duration : { text: 'Unavailable', value: 0 }
          resolve(duration)
        } else {
          reject(data)
        }
      })
    })
  }

  public async getPlaceDetails(placeId: string) {
    const request = {
      placeId,
      fields: ['address_components', 'formatted_address', 'geometry', 'name']
    }
    return new Promise((resolve, reject) => {
      this.placesService.getDetails(request, (data: any, status: string) => {
        if (status === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      })
    })
  }

  public async reverseGeocode(coordinates: ICoordinatesWithShortKeyDTO) {
    return new Promise((resolve, reject) => {
      this.geocoder.geocode({ location: coordinates }, (data: any, status: string) => {
        if (status === 'OK') {
          const location = data instanceof Array ? data[0] : data
          resolve({
            formatted_address: location.formatted_address
          })
        } else {
          reject(data)
        }
      })
    })
  }
}

const googleMapService = new GoogleMapService()
export { googleMapService }



// WEBPACK FOOTER //
// ./src/services/GoogleMap.ts